import { useMutation } from '@apollo/client';
import { GET_PATIENTS } from '../gqlSchemes/getPatients';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { REACTIVATE_PATIENT } from '../gqlSchemes/reactivatePatient';
import { getMessageFromError } from "lib/enums/errorCodes"

export default function useReactivatePatient() {
  const [reactivate] = useMutation(REACTIVATE_PATIENT);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const reactivatePatient = ({ id, careTeamIds }) => {
    reactivate({
      variables: {
        record: {
          id,
          careTeamIds,
        },
      },
      onCompleted: async (res) => {
        if (res.user.patientUser.activatePatient.ok) {
          enqueueSnackbar(t('Patient was successfully reactivated'), {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
        } else {
          enqueueSnackbar(getMessageFromError(res.user.patientUser.activatePatient.error, t), {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
        }
      },
      refetchQueries: [GET_PATIENTS],
    });
  };

  return { reactivatePatient };
}
